import React from 'react';
import { HiMoon, HiSun } from 'react-icons/hi';
import { useTheme } from '../../context/ThemeContext';

/**
 * ThemeToggle — moon / sun button for dark & light mode.
 *
 * Shows a MOON when light mode is on (click → dark mode) and a SUN when
 * dark mode is on (click → light mode).
 */
const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={`
        inline-flex items-center justify-center w-10 h-10 rounded-xl
        transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500
        ${isDark
          ? 'bg-primary-500/15 text-amber-300 hover:bg-primary-500/25 border border-primary-400/30 shadow-lg shadow-primary-500/20 backdrop-blur-sm'
          : 'bg-white text-indigo-500 hover:bg-indigo-50 shadow-lg shadow-indigo-500/20 border border-gray-200'}
        ${className}
      `}
    >
      {/* Moon when light (click → dark) · Sun when dark (click → light) */}
      {isDark ? <HiSun className="w-5 h-5" /> : <HiMoon className="w-5 h-5" />}
    </button>
  );
};

export default ThemeToggle;